<ng-container *ngIf="failure() as current">
  <div class="flex-grow-1 mw-100">
    <p class="m-0" data-testid="link-failure-message">{{ message }}</p>
    <span class="text-break user-select-all fw-bold" data-testid="link-failure-url">{{
      current.url
    }}</span>
    <p *ngIf="copyState() === 'failed'" class="m-0 mt-1" data-testid="link-failure-copy-failed">
      {{ copyFailedLabel }}
    </p>
  </div>
  <button
    class="btn btn-sm btn-outline-secondary flex-shrink-0"
    data-testid="button-copy-link"
    type="button"
    (click)="copy(current.url)"
  >
    {{ copyState() === "copied" ? copiedLabel : copyLabel }}
  </button>
  <button
    class="flex-shrink-0"
    data-testid="button-close"
    type="button"
    icon="close"
    (click)="dismiss()"
    title="-"
    i18n-title="@@link-failure.close"
  ></button>
</ng-container>
